import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  ListGroup,
  Badge,
  Table,
  Spinner,
  Alert,
  Accordion,
} from "react-bootstrap";
import { useRef, useEffect, useState } from "react";
import axios from "axios";
import { translations } from "../../translations";

export default function DomainReport() {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reportRef = useRef();

  const t = translations.eng;

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/reports/cyber-reports/${userId}`);
        if (!response.data) {
          throw new Error(t.noDataReceived);
        }

        setReportData(response.data.response);
      } catch (err) {
        setError(err.message || t.failedToLoadReport);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [userId]);

  const downloadPDF = () => {
    const link = document.createElement("a");

    link.href = reportData.pdfUrl;
    link.download = t.reportPdf;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">{t.loading}</span>
        </Spinner>
        <p className="mt-2">{t.loadingSecurityReport}</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5">
        <Alert variant="danger">
          <Alert.Heading>{t.errorLoadingReport}</Alert.Heading>
          <p>{error}</p>
          <Button variant="primary" onClick={() => navigate("/")}>
            {t.backToHome}
          </Button>
        </Alert>
      </div>
    );
  }

  if (!reportData) {
    return (
      <div className="container mt-5">
        <Alert variant="warning">
          <Alert.Heading>{t.noReportDataAvailable}</Alert.Heading>
          <p>{t.pleaseSubmitDomainFirst}</p>
          <Button variant="primary" onClick={() => navigate("/")}>
            {t.backToHome}
          </Button>
        </Alert>
      </div>
    );
  }

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #f0f4fb 0%, #ffffff 100%)",
        padding: "2rem 0",
        minHeight: "100vh",
      }}
    >


      <div className="container my-5">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch gap-3 mb-4">
          {/* <Button
            variant="outline-primary"
            onClick={() => navigate("/")}
            className="py-2 px-4 d-flex align-items-center justify-content-center"
          >
            <i className="bi bi-arrow-left-circle me-2"></i>
            {t.backToAssessment}
          </Button> */}

          <Button
            variant="success"
            onClick={downloadPDF}
            className="py-2 px-4 d-flex align-items-center justify-content-center"
          >
            <i className="bi bi-file-earmark-pdf me-2"></i>
            {t.downloadFullReport}
          </Button>
        </div>

        <div ref={reportRef}>
          <Card
            className="border-0 shadow-lg"
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
          >
            <Card.Header
              className="py-3"
              style={{
                backgroundColor: "#23416c",
                background: "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                color: "white",
                borderBottom: "2px solid rgba(165, 81, 81, 0.1)",
              }}
            >
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                <div className="d-flex align-items-center">
                  <i
                    className="bi bi-shield-check me-3"
                    style={{ fontSize: "1.75rem" }}
                  ></i>
                  <h2 className="mb-0">{t.domainSecurityReport}</h2>
                </div>
                {/* <Badge bg="light" text="dark" pill className="align-self-center">
          <i className="bi bi-clipboard-data me-1"></i>
          Report ID: {userId}
        </Badge> */}
              </div>
            </Card.Header>

            <Card.Body
              className="pt-4 pb-3"
              style={{ backgroundColor: "rgba(255,255,255,0.98)" }}
            >
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center mb-3 mb-md-0">
                  <div className="d-flex align-items-center me-md-3 mb-2 mb-md-0">
                    <i
                      className="bi bi-globe me-2 text-muted"
                      style={{ fontSize: "1.5rem" }}
                    ></i>
                    <h3 className="mb-0 text-break">{reportData.domain}</h3>
                  </div>

                  <div className="d-flex flex-wrap gap-2">
                    {reportData.ssl && (
                      <Badge
                        pill
                        className="d-flex align-items-center bg-success bg-opacity-10 text-success px-3 py-2"
                      >
                        <i className="bi bi-lock-fill me-1"></i>
                        {t.sslSecured}
                      </Badge>
                    )}
                  </div>
                </div>

                {/* <Badge pill className="d-flex align-items-center bg-secondary bg-opacity-10 text-secondary px-3 py-2">
          <i className="bi bi-clock-history me-1"></i>
          Last scanned: {new Date(reportData.updatedAt || Date.now()).toLocaleString()}
        </Badge> */}
              </div>

              {/* 🎨 Modern Overall Score Section with Bootstrap */}
              <div className="card shadow-sm mb-4 border-0 overflow-hidden">
                {/* <div className="card-header py-3 text-white" style={{ 
    backgroundColor: "#23416c",
    background: "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)"
  }}>
    <h5 className="mb-0 d-flex align-items-center">
      <i className="bi bi-speedometer2 me-2"></i>
      <strong>OVERALL SCORE</strong>
    </h5>
  </div> */}

                <div
                  className="card-body p-4"
                  style={{ backgroundColor: "#f8fafc" }}
                >
                  <div className="d-flex align-items-center mb-3">
                    <div className="me-3">
                      <div className="display-5 fw-bold text-primary">
                        {reportData.overAllRiskScore ?? t.na}
                      </div>
                    </div>
                    <div>
                      <span className="badge bg-primary bg-opacity-10 text-primary py-2 px-3 fs-6">
                        {t.overallRiskScore}
                      </span>
                      <div className="progress mt-2" style={{ height: "6px" }}>
                        <div
                          className="progress-bar bg-primary"
                          role="progressbar"
                          style={{
                            width: `${Math.min(
                              reportData.overAllRiskScore || 0,
                              100
                            )}%`,
                          }}
                          aria-valuenow={reportData.overAllRiskScore || 0}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="alert alert-light border mt-3 mb-0">
                    <p className="mb-0">
                      <i className="bi bi-info-circle-fill text-primary me-2"></i>
                      {reportData.summary || t.noSummaryAvailable}
                    </p>
                  </div>
                </div>
              </div>
              {/* 🆕 Modern Basic Information Card */}
              <div className="card mb-4 border-0 shadow-sm overflow-hidden">
                <div
                  className="card-header py-3 text-white"
                  style={{
                    backgroundColor: "#23416c",
                    background:
                      "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-info-circle me-2"></i>
                    <strong>BASIC INFORMATION</strong>
                  </h5>
                </div>

                <div className="card-body p-0">
                  <div className="list-group list-group-flush">
                    {[
                      { label: t.domain, value: reportData.domain },
                      { label: t.ipAddress, value: reportData.ipAddress },
                      {
                        label: t.networkPerformance,
                        value:
                          reportData.packetLoss || reportData.rtt ? (
                            <div className="d-flex flex-wrap gap-3">
                              <span
                                className={`badge ${
                                  reportData.packetLoss?.includes("0%")
                                    ? "bg-success bg-opacity-10 text-success"
                                    : "bg-danger bg-opacity-10 text-danger"
                                } p-2`}
                              >
                                <i
                                  className={`bi ${
                                    reportData.packetLoss?.includes("0%")
                                      ? "bi-check-circle"
                                      : "bi-exclamation-triangle"
                                  } me-1`}
                                ></i>
                                {t.packetLoss}: {reportData.packetLoss || t.na}
                              </span>
                              <span className="badge bg-info bg-opacity-10 text-info p-2">
                                <i className="bi bi-speedometer2 me-1"></i>
                                {t.rtt}: {reportData.rtt || t.na}
                              </span>
                            </div>
                          ) : null,
                        condition: reportData.packetLoss || reportData.rtt,
                      },
                      { label: t.server, value: reportData.server },
                      { label: t.rootDomain, value: reportData.root_domain },
                      { label: t.city, value: reportData.city },
                      { label: t.region, value: reportData.region },
                      { label: t.country, value: reportData.country },
                      { label: t.countryCode, value: reportData.countryCode },
                      { label: t.isp, value: reportData.isp },
                      { label: t.latitude, value: reportData.lat },
                      { label: t.longitude, value: reportData.lon },
                      { label: t.timezone, value: reportData.timezone },
                      { label: t.zip, value: reportData.zip },
                    ]
                      .filter(
                        (item) =>
                          item.value !== "" &&
                          item.value !== null &&
                          item.value !== undefined &&
                          (item.condition === undefined || item.condition)
                      )
                      .map((item, idx) => (
                        <div
                          className="list-group-item border-0 py-1"
                          key={idx}
                        >
                          <div className="row align-items-center">
                            <div className="col-md-4">
                              <span className="text-muted small text-uppercase fw-semibold">
                                {item.label}
                              </span>
                            </div>
                            <div className="col-md-8">
                              <div
                                className={`p-2 rounded ${
                                  typeof item.value === "string"
                                    ? "text-dark"
                                    : ""
                                }`}
                              >
                                {item.value || (
                                  <span className="text-muted">{t.na}</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div className="card mb-4 border-0 shadow-sm overflow-hidden">
                <div
                  className="card-header py-3 text-white"
                  style={{
                    backgroundColor: "#23416c",
                    background:
                      "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-building me-2"></i>
                    <strong>REGISTRAR INFORMATION</strong>
                  </h5>
                </div>

                <div className="card-body p-0">
                  <div className="list-group list-group-flush">
                    {[
                      {
                        label: t.dnssec,
                        value: reportData.dnssec && (
                          <span
                            className={`badge ${
                              reportData.dnssec === "signed"
                                ? "bg-success bg-opacity-10 text-success"
                                : "bg-warning bg-opacity-10 text-warning"
                            } p-2`}
                          >
                            <i
                              className={`bi ${
                                reportData.dnssec === "signed"
                                  ? "bi-shield-check"
                                  : "bi-shield-exclamation"
                              } me-1`}
                            ></i>
                            {reportData.dnssec === "signed"
                              ? t.signed
                              : t.unsigned}
                          </span>
                        ),
                        condition: reportData.dnssec !== "",
                      },
                      { label: t.registrar, value: reportData.registrar },
                      { label: t.registrarUrl, value: reportData.registrarUrl },
                      {
                        label: t.registrantCountry,
                        value: (
                          <div className="d-flex align-items-center">
                            <i className="bi bi-globe me-2 text-muted"></i>
                            {reportData.registrantCountry}
                          </div>
                        ),
                        condition: reportData.registrantCountry !== "",
                      },
                      {
                        label: t.registrantStateProvince,
                        value: reportData.registrantStateProvince,
                        condition: reportData.registrantStateProvince !== "",
                      },
                      {
                        label: t.registrantEmail,
                        value: (
                          <a
                            href={`mailto:${reportData.registrantEmail}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none"
                          >
                            <span className="badge bg-info bg-opacity-10 text-info p-2">
                              <i className="bi bi-envelope me-1"></i>
                              {reportData.registrantEmail}
                            </span>
                          </a>
                        ),
                        condition: reportData.registrantEmail !== "",
                      },
                      {
                        label: t.nameServers,
                        value: (
                          <div className="d-flex flex-wrap gap-2">
                            {reportData.nameServers?.map((server, i) => (
                              <span
                                key={i}
                                className="badge bg-light text-dark p-2"
                              >
                                <i className="bi bi-server me-1"></i>
                                {server}
                              </span>
                            ))}
                          </div>
                        ),
                        condition: reportData.nameServers?.length > 0,
                      },
                      {
                        label: t.registrarAbuseContact,
                        value: (
                          <div className="d-flex flex-column gap-2">
                            {reportData.registrarAbuseContactEmail && (
                              <a
                                href={`mailto:${reportData.registrarAbuseContactEmail}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-decoration-none"
                              >
                                <span className="badge bg-danger bg-opacity-10 text-danger p-2">
                                  <i className="bi bi-envelope me-1"></i>
                                  {reportData.registrarAbuseContactEmail}
                                </span>
                              </a>
                            )}
                            {reportData.registrarAbuseContactPhone && (
                              <a
                                href={`tel:${reportData.registrarAbuseContactPhone.replace(
                                  /[^0-9+]/g,
                                  ""
                                )}`}
                                className="text-decoration-none"
                              >
                                <span className="badge bg-danger bg-opacity-10 text-danger p-2">
                                  <i className="bi bi-telephone me-1"></i>
                                  {reportData.registrarAbuseContactPhone}
                                </span>
                              </a>
                            )}
                          </div>
                        ),
                        condition:
                          reportData.registrarAbuseContactEmail !== "" ||
                          reportData.registrarAbuseContactPhone !== "",
                      },
                      {
                        label: t.registrarWhoisServer,
                        value: (
                          <div className="d-flex align-items-center">
                            <i className="bi bi-database me-2 text-muted"></i>
                            {reportData.registrarWhoisServer}
                          </div>
                        ),
                        condition: reportData.registrarWhoisServer !== "",
                      },
                    ]
                      .filter((item) => item.condition)
                      .map((item, idx) => (
                        <div
                          className="list-group-item border-0 py-3"
                          key={idx}
                        >
                          <div className="row align-items-center">
                            <div className="col-md-4">
                              <span className="text-muted small text-uppercase fw-semibold">
                                {item.label}
                              </span>
                            </div>
                            <div className="col-md-8">
                              <div className="p-0">
                                {item.value || (
                                  <span className="text-muted">{t.na}</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <Card className="mb-4 border-0 shadow-sm">
                <Card.Header
                  className="text-white py-3"
                  style={{
                    backgroundColor: "#23416c",
                    background:
                      "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-diagram-3 me-2"></i>
                    <strong>{t.dnsRecords}</strong>
                  </h5>
                </Card.Header>

                <Card.Body className="p-0">
                  {/* A Records */}
                  <div className="p-3 border-bottom">
                    <div className="row align-items-center">
                      <div className="col-md-2">
                        <span className="text-muted small text-uppercase fw-semibold">
                          A Records
                        </span>
                      </div>
                      <div className="col-md-10">
                        <div className="d-flex flex-wrap gap-2">
                          {reportData.dnsRecords?.A?.length > 0 ? (
                            reportData.dnsRecords.A.map((record, i) => (
                              <Badge
                                key={`a-${i}`}
                                bg="primary"
                                className="d-flex align-items-center px-3 py-2"
                              >
                                <i className="bi bi-globe me-1"></i>
                                {record}
                              </Badge>
                            ))
                          ) : (
                            <span className="text-muted small">
                              No A records found
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* MX Records */}
                  <div className="p-3 border-bottom">
                    <div className="row align-items-center">
                      <div className="col-md-2">
                        <span className="text-muted small text-uppercase fw-semibold">
                          MX Records
                        </span>
                      </div>
                      <div className="col-md-10">
                        <div className="d-flex flex-wrap gap-2">
                          {reportData.dnsRecords?.MX?.length > 0 ? (
                            reportData.dnsRecords.MX.map((record, i) => (
                              <Badge
                                key={`mx-${i}`}
                                bg="success"
                                className="d-flex align-items-center px-3 py-2"
                              >
                                <i className="bi bi-envelope me-1"></i>
                                {record}
                              </Badge>
                            ))
                          ) : (
                            <span className="text-muted small">
                              No MX records found
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* NS Records */}
                  <div className="p-3">
                    <div className="row align-items-center">
                      <div className="col-md-2">
                        <span className="text-muted small text-uppercase fw-semibold">
                          NS Records
                        </span>
                      </div>
                      <div className="col-md-10">
                        <div className="d-flex flex-wrap gap-2">
                          {reportData.dnsRecords?.NS?.length > 0 ? (
                            reportData.dnsRecords.NS.map((record, i) => (
                              <Badge
                                key={`ns-${i}`}
                                bg="info"
                                className="d-flex align-items-center px-3 py-2"
                              >
                                <i className="bi bi-server me-1"></i>
                                {record}
                              </Badge>
                            ))
                          ) : (
                            <span className="text-muted small">
                              No NS records found
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
              {/* SSL Certificate */}
              {reportData.ssl && (
                <Card className="mb-4 border-0 shadow-sm">
                  <Card.Header
                    className="text-white py-3"
                    style={{
                      backgroundColor: "#23416c",
                      background:
                        "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                    }}
                  >
                    <h5 className="mb-0 d-flex align-items-center">
                      <i className="bi bi-shield-lock me-2"></i>
                      <strong>{t.sslCertificate}</strong>
                    </h5>
                  </Card.Header>

                  <Card.Body className="p-0">
                    <div className="list-group list-group-flush">
                      {/* Issuer */}
                      <div className="list-group-item border-0 py-3">
                        <div className="row align-items-center">
                          <div className="col-md-5">
                            <span className="text-muted small text-uppercase fw-semibold">
                              Issuer
                            </span>
                          </div>
                          <div className="col-md-7">
                            <div className="p-2 rounded bg-light bg-opacity-10 text-break">
                              {reportData.ssl.issuer || (
                                <span className="text-muted">Unknown</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Expiration */}
                      <div className="list-group-item border-0 py-3">
                        <div className="row align-items-center">
                          <div className="col-md-5">
                            <span className="text-muted small text-uppercase fw-semibold">
                              Expires
                            </span>
                          </div>
                          <div className="col-md-7">
                            <div
                              className={`p-2 rounded ${
                                new Date(reportData.ssl.expires) < new Date()
                                  ? "bg-danger bg-opacity-10"
                                  : "bg-success bg-opacity-10"
                              }`}
                            >
                              <span
                                className={`d-flex align-items-center ${
                                  new Date(reportData.ssl.expires) < new Date()
                                    ? "text-danger"
                                    : "text-success"
                                }`}
                              >
                                <i
                                  className={`bi ${
                                    new Date(reportData.ssl.expires) <
                                    new Date()
                                      ? "bi-exclamation-triangle-fill"
                                      : "bi-check-circle-fill"
                                  } me-2`}
                                ></i>
                                {new Date(
                                  reportData.ssl.expires
                                ).toLocaleDateString()}
                                {new Date(reportData.ssl.expires) <
                                  new Date() && (
                                  <Badge bg="danger" className="ms-2">
                                    {t.expired}
                                  </Badge>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Additional SSL Info (if available) */}
                      {reportData.ssl.validFrom && (
                        <div className="list-group-item border-0 py-3">
                          <div className="row align-items-center">
                            <div className="col-md-5">
                              <span className="text-muted small text-uppercase fw-semibold">
                                Valid From
                              </span>
                            </div>
                            <div className="col-md-7">
                              <div className="p-2 rounded bg-light bg-opacity-10">
                                {new Date(
                                  reportData.ssl.validFrom
                                ).toLocaleDateString()}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {reportData.ssl.algorithm && (
                        <div className="list-group-item border-0 py-3">
                          <div className="row align-items-center">
                            <div className="col-md-5">
                              <span className="text-muted small text-uppercase fw-semibold">
                                Algorithm
                              </span>
                            </div>
                            <div className="col-md-7">
                              <div className="p-2 rounded bg-light bg-opacity-10">
                                {reportData.ssl.algorithm}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              )}

              {reportData.ports && reportData.ports.length > 0 && (
                <Card className="mb-4 border-0 shadow-sm">
                  <Card.Header
                    className="text-white py-3 text-center"
                    style={{
                      backgroundColor: "#23416c",
                      background:
                        "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                    }}
                  >
                    <h5 className="mb-0 d-flex align-items-center ">
                      <i className="bi bi-ethernet me-2"></i>
                      <strong>
                        {t.openPorts} ({reportData.ports.length})
                      </strong>
                      <Badge bg="light" text="dark" pill className="ms-2">
                        <i className="bi bi-exclamation-triangle-fill text-warning me-1"></i>
                        {
                          reportData.ports.filter((p) => p.state === "open")
                            .length
                        }{" "}
                        {t.open}
                      </Badge>
                    </h5>
                  </Card.Header>

                  <Card.Body className="p-0">
                    <div className="table-responsive">
                      <Table hover className="mb-0">
                        <thead style={{ backgroundColor: "#f8f9fa" }}>
                          <tr>
                            <th
                              className="text-center"
                              style={{ width: "33%" }}
                            >
                              Port
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "33%" }}
                            >
                              Status
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "34%" }}
                            >
                              Service
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {reportData.ports.map((port, index) => (
                            <tr key={index}>
                              <td className="text-center">
                                <span
                                  className={`badge ${
                                    port.state === "open"
                                      ? "bg-danger bg-opacity-10 text-danger"
                                      : "bg-secondary bg-opacity-10 text-secondary"
                                  } px-3 py-2 rounded-pill d-inline-flex align-items-center`}
                                >
                                  <i
                                    className={`bi ${
                                      port.port === 80
                                        ? "bi-globe"
                                        : port.port === 443
                                        ? "bi-lock-fill"
                                        : "bi-plug"
                                    } me-2`}
                                  ></i>
                                  {port.port}
                                </span>
                              </td>
                              <td className="text-center">
                                <span
                                  className={`badge ${
                                    port.state === "open"
                                      ? "bg-danger bg-opacity-10 text-danger"
                                      : "bg-secondary bg-opacity-10 text-secondary"
                                  } px-3 py-2 rounded-pill d-inline-flex align-items-center`}
                                >
                                  <i
                                    className={`bi ${
                                      port.state === "open"
                                        ? "bi-unlock-fill me-2"
                                        : "bi-lock-fill me-2"
                                    }`}
                                  ></i>
                                  {port.state.toUpperCase()}
                                </span>
                              </td>
                              <td className="text-center">
                                {port.service || t.unknown}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    {/* Summary Footer */}
                    <div className="p-3 bg-light border-top small">
                      <div className="d-flex justify-content-center gap-4">
                        <span className="text-success">
                          <i className="bi bi-check-circle-fill me-1"></i>
                          {t.closed}:{" "}
                          {
                            reportData.ports.filter((p) => p.state !== "open")
                              .length
                          }
                        </span>
                        <span className="text-danger">
                          <i className="bi bi-exclamation-triangle-fill me-1"></i>
                          {t.openLabel}:{" "}
                          {
                            reportData.ports.filter((p) => p.state === "open")
                              .length
                          }
                        </span>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              )}

              {reportData.httpHeaders && reportData.httpHeaders.length > 0 && (
                <Card className="mb-4 border-0 shadow-sm">
                  <Card.Header
                    className="text-white py-3 text-center"
                    style={{
                      backgroundColor: "#23416c",
                      background:
                        "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                    }}
                  >
                    <h5 className="mb-0 d-flex align-items-center ">
                      <i className="bi bi-code-square me-2"></i>
                      <strong>
                        {t.httpHeaders} ({reportData.httpHeaders.length})
                      </strong>
                    </h5>
                  </Card.Header>

                  <Card.Body className="p-0">
                    <div className="table-responsive">
                      <Table hover className="mb-0">
                        <thead style={{ backgroundColor: "#f8f9fa" }}>
                          <tr>
                            <th
                              className="text-center py-3"
                              style={{ width: "30%" }}
                            >
                              Header Name
                            </th>
                            <th
                              className="text-center py-3"
                              style={{ width: "70%" }}
                            >
                              Header Value
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {reportData.httpHeaders.map((header, index) => (
                            <tr key={index}>
                              <td
                                className="ps-4 fw-semibold"
                                style={{ color: "rgb(35 65 108)" }}
                              >
                                <div className="d-flex align-items-center">
                                  <i className="bi bi-tag-fill me-2 text-muted"></i>
                                  {header.name}
                                </div>
                              </td>
                              <td className="text-break pe-4">
                                <code className="bg-light bg-opacity-10 p-1 rounded">
                                  {header.value}
                                </code>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </Card.Body>
                </Card>
              )}

              <Card className="mb-4 border-0 shadow-sm">
                <Card.Header
                  className="text-white py-3 text-center"
                  style={{
                    backgroundColor: "#23416c",
                    background:
                      "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-collection me-2"></i>
                    <strong>
                      SUBDOMAINS ({reportData.subdomains?.length || 0})
                    </strong>
                  </h5>
                </Card.Header>

                <Card.Body className="p-1">
                  {reportData.subdomains?.length > 0 ? (
                    <div className="d-flex flex-wrap gap-3">
                      {reportData.subdomains.map((subdomain, i) => (
                        <Badge
                          key={i}
                          bg="info"
                          className="d-flex align-items-center px-3 py-2 rounded-pill text-break"
                          style={{
                            maxWidth: "100%",
                            backgroundColor: "rgba(13, 110, 253, 0.1)",
                            color: "#0d6efd",
                          }}
                        >
                          <i className="bi bi-box-arrow-up-right me-2"></i>
                          {subdomain}
                        </Badge>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-3">
                      <i
                        className="bi bi-search text-muted"
                        style={{ fontSize: "2rem" }}
                      ></i>
                      <p className="text-muted mt-2 mb-0">
                        No subdomains detected
                      </p>
                    </div>
                  )}
                </Card.Body>

                {reportData.subdomains?.length > 0 && (
                  <Card.Footer className="bg-light border-top py-2 small">
                    <div className="text-center text-muted">
                      Showing {reportData.subdomains.length} subdomains
                    </div>
                  </Card.Footer>
                )}
              </Card>

              <Card className="mb-4 border-0 shadow-sm">
                <Card.Header
                  className="text-white py-3 text-center"
                  style={{
                    backgroundColor: "#23416c",
                    background:
                      "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center ">
                    <i className="bi bi-shield-exclamation me-2"></i>
                    <strong>DOMAIN BREACH STATUS</strong>
                  </h5>
                </Card.Header>

                <Card.Body className="p-4">
                  <div className="text-center mb-3">
                    <Badge
                      pill
                      className={`px-4 py-3 d-inline-flex align-items-center ${
                        reportData.domainBreach?.breachFound
                          ? "bg-danger bg-opacity-10 text-danger"
                          : "bg-success bg-opacity-10 text-success"
                      }`}
                    >
                      <i
                        className={`bi ${
                          reportData.domainBreach?.breachFound
                            ? "bi-exclamation-triangle-fill me-2"
                            : "bi-check-circle-fill me-2"
                        }`}
                      ></i>
                      {reportData.domainBreach?.breachFound
                        ? t.breachDetected
                        : t.noBreachesFound}
                    </Badge>
                  </div>

                  {reportData.domainBreach?.breaches?.length > 0 && (
                    <div className="mt-4">
                      <h6
                        className="fw-semibold mb-3 d-flex align-items-center"
                        style={{ color: "rgb(35 65 108)" }}
                      >
                        <i className="bi bi-list-ul me-2"></i>
                        Related Breaches:
                      </h6>
                      <ul className="list-group">
                        {reportData.domainBreach.breaches.map((breach, i) => (
                          <li
                            key={i}
                            className="list-group-item d-flex align-items-center text-break border-0 py-2"
                            style={{
                              backgroundColor: "rgba(220, 53, 69, 0.05)",
                            }}
                          >
                            <i className="bi bi-dot text-danger me-2"></i>
                            {breach}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </Card.Body>
              </Card>

              {reportData.blacklists_engine &&
                reportData.blacklists_engine.length > 0 && (
                  <Card className="mb-4 border-0 shadow-sm">
                    <Card.Header
                      className="text-white py-3 text-center"
                      style={{
                        backgroundColor: "#23416c",
                        background:
                          "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                      }}
                    >
                      <h5 className="mb-0 d-flex align-items-center ">
                        <i className="bi bi-shield-slash me-2"></i>
                        <strong>
                          BLACKLIST CHECK ({reportData.blacklists_engine.length}{" "}
                          lists)
                        </strong>
                      </h5>
                    </Card.Header>

                    <Card.Body className="p-0">
                      <div className="table-responsive">
                        <Table hover className="mb-0">
                          <thead style={{ backgroundColor: "#f8f9fa" }}>
                            <tr>
                              <th className="ps-4 py-3">List Name</th>
                              <th className="py-3">List Host</th>
                              <th className="pe-4 py-3 text-center">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {reportData.blacklists_engine.map((list, index) => (
                              <tr key={index}>
                                <td
                                  className="ps-4 fw-semibold"
                                  style={{ color: "rgb(35 65 108)" }}
                                >
                                  <div className="d-flex align-items-center">
                                    <i className="bi bi-list-check me-2 text-muted"></i>
                                    {list.list_name}
                                  </div>
                                </td>
                                <td className="text-break">
                                  <code className="bg-light bg-opacity-10 p-1 rounded">
                                    {list.list_host}
                                  </code>
                                </td>
                                <td className="pe-4 text-center">
                                  <Badge
                                    pill
                                    className={`px-3 py-2 d-inline-flex align-items-center ${
                                      list.is_listed
                                        ? "bg-danger bg-opacity-10 text-danger"
                                        : "bg-success bg-opacity-10 text-success"
                                    }`}
                                  >
                                    <i
                                      className={`bi ${
                                        list.is_listed
                                          ? "bi-exclamation-triangle-fill me-2"
                                          : "bi-check-circle-fill me-2"
                                      }`}
                                    ></i>
                                    {list.is_listed ? t.listed : t.clean}
                                  </Badge>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>

                      {/* Summary Footer */}
                      <div className="p-3 bg-light border-top small">
                        <div className="d-flex justify-content-between">
                          <div>
                            <span className="text-success">
                              <i className="bi bi-check-circle-fill me-1"></i>
                              Clean:{" "}
                              {
                                reportData.blacklists_engine.filter(
                                  (l) => !l.is_listed
                                ).length
                              }
                            </span>
                          </div>
                          <div>
                            <span className="text-danger">
                              <i className="bi bi-exclamation-triangle-fill me-1"></i>
                              Listed:{" "}
                              {
                                reportData.blacklists_engine.filter(
                                  (l) => l.is_listed
                                ).length
                              }
                            </span>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                )}

              {reportData?.assetAndVulner &&
                reportData?.assetAndVulner.length > 0 && (
                  <Card className="mb-4 border-0 shadow-sm">
                    <Card.Header
                      className="text-white py-3"
                      style={{
                        backgroundColor: "#23416c",
                        background:
                          "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                      }}
                    >
                      <h5 className="mb-0 d-flex align-items-center justify-content-center">
                        <i className="bi bi-bug-fill me-2"></i>
                        <strong>
                          {t.detectedTechnologiesVulnerabilities} (
                          {reportData.assetAndVulner.length})
                        </strong>
                      </h5>
                    </Card.Header>

                    <Card.Body className="p-0">
                      <Accordion flush>
                        {reportData.assetAndVulner.map((asset, index) => (
                          <Accordion.Item
                            eventKey={index.toString()}
                            key={index}
                            className="border-bottom"
                          >
                            <Accordion.Header className="py-3 px-4">
                              <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 w-100">
                                <div className="d-flex align-items-center flex-grow-1">
                                  <i className="bi bi-box-seam me-2 text-muted"></i>
                                  <span
                                    className="fw-bold"
                                    style={{ color: "rgb(35 65 108)" }}
                                  >
                                    {asset.name}
                                  </span>
                                </div>

                                <div className="d-flex flex-wrap gap-2">
                                  {asset.baseSeverity &&
                                    asset.baseSeverity !== t.na && (
                                      <Badge
                                        pill
                                        className={`px-3 py-2 d-flex align-items-center ${
                                          asset.baseSeverity === "CRITICAL"
                                            ? "bg-danger bg-opacity-10 text-danger"
                                            : asset.baseSeverity === "HIGH"
                                            ? "bg-warning bg-opacity-10 text-warning"
                                            : asset.baseSeverity === "MEDIUM"
                                            ? "bg-primary bg-opacity-10 text-primary"
                                            : "bg-secondary bg-opacity-10 text-secondary"
                                        }`}
                                      >
                                        <i
                                          className={`bi ${
                                            asset.baseSeverity === "CRITICAL"
                                              ? "bi-exclamation-octagon-fill"
                                              : asset.baseSeverity === "HIGH"
                                              ? "bi-exclamation-triangle-fill"
                                              : "bi-info-circle-fill"
                                          } me-1`}
                                        ></i>
                                        {asset.baseSeverity}
                                      </Badge>
                                    )}

                                  {asset.version && asset.version !== t.na && (
                                    <Badge
                                      pill
                                      className="bg-info bg-opacity-10 text-info px-3 py-2 d-flex align-items-center"
                                    >
                                      <i className="bi bi-tag-fill me-1"></i>v
                                      {asset.version}
                                    </Badge>
                                  )}
                                </div>
                              </div>
                            </Accordion.Header>

                            <Accordion.Body className="px-4 py-3">
                              <div className="vulnerability-details">
                                {asset.description && (
                                  <div className="mb-3">
                                    <h6 className="d-flex align-items-center text-muted mb-2">
                                      <i className="bi bi-card-text me-2"></i>
                                      Description
                                    </h6>
                                    <p className="mb-0">{asset.description}</p>
                                  </div>
                                )}

                                <div className="row g-3 mb-3">
                                  {asset.confidence && (
                                    <div className="col-md-6">
                                      <h6 className="d-flex align-items-center text-muted mb-2">
                                        <i className="bi bi-activity me-2"></i>
                                        Confidence
                                      </h6>
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="progress flex-grow-1"
                                          style={{ height: "8px" }}
                                        >
                                          <div
                                            className="progress-bar bg-primary"
                                            role="progressbar"
                                            style={{
                                              width: `${asset.confidence}%`,
                                            }}
                                            aria-valuenow={asset.confidence}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                          ></div>
                                        </div>
                                        <span className="ms-2 fw-bold">
                                          {asset.confidence}%
                                        </span>
                                      </div>
                                    </div>
                                  )}

                                  {asset.baseScore > 0 && (
                                    <div className="col-md-6">
                                      <h6 className="d-flex align-items-center text-muted mb-2">
                                        <i className="bi bi-speedometer2 me-2"></i>
                                        CVSS Score
                                      </h6>
                                      <div className="d-flex align-items-center">
                                        <Badge
                                          bg={
                                            asset.baseScore >= 9
                                              ? "danger"
                                              : asset.baseScore >= 7
                                              ? "warning"
                                              : asset.baseScore >= 4
                                              ? "primary"
                                              : "secondary"
                                          }
                                          className="me-2"
                                        >
                                          {asset.baseScore}
                                        </Badge>
                                        <span>({asset.baseSeverity})</span>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                {asset.cveId && asset.cveId !== t.na && (
                                  <div className="mb-3">
                                    <h6 className="d-flex align-items-center text-muted mb-2">
                                      <i className="bi bi-shield-shaded me-2"></i>
                                      Vulnerability Reference
                                    </h6>
                                    <a
                                      href={asset.cveIdlink}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                                    >
                                      <i className="bi bi-link-45deg me-1"></i>
                                      {asset.cveId}
                                    </a>
                                  </div>
                                )}

                                <div className="d-flex flex-wrap gap-2 mt-3">
                                  {/* <a
                                    href="https://nvd.nist.gov/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                                  >
                                    <i className="bi bi-search me-1"></i>
                                    Check NIST Database
                                  </a> */}

                                  {asset.exploitabilityScore > 0 && (
                                    <Badge
                                      bg="dark"
                                      className="d-flex align-items-center"
                                    >
                                      <i className="bi bi-lightning-charge-fill me-1"></i>
                                      {t.exploitability}:{" "}
                                      {asset.exploitabilityScore}
                                    </Badge>
                                  )}

                                  {asset.impactScore > 0 && (
                                    <Badge
                                      bg="dark"
                                      className="d-flex align-items-center"
                                    >
                                      <i className="bi bi-heartbreak-fill me-1"></i>
                                      {t.impact}: {asset.impactScore}
                                    </Badge>
                                  )}

                                  {asset.baseScore > 0 && (
                                    <Badge
                                      bg="dark"
                                      className="d-flex align-items-center"
                                    >
                                      <i className="bi bi-heartbreak-fill me-1"></i>
                                      {t.baseScore}: {asset.baseScore}
                                    </Badge>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                      </Accordion>
                    </Card.Body>
                  </Card>
                )}
              <Card className="mb-4 border-0 shadow-sm">
                <Card.Header
                  className="text-white py-3"
                  style={{
                    backgroundColor: "#23416c",
                    background:
                      "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center ">
                    <i className="bi bi-envelope-shield me-2"></i>
                    <strong>SECURITY CONFIGURATION</strong>
                  </h5>
                </Card.Header>

                <Card.Body className="p-0">
                  <div className="table-responsive">
                    <Table hover className="mb-0 align-middle">
                      <tbody>
                        <tr>
                          <td className="ps-4 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-shield-check me-2 text-muted"></i>
                            DMARC Record
                          </td>
                          <td className="pe-4 p-0">
                            <div
                              className={`px-3 py-1 rounded-5 d-flex align-items-center ${
                                reportData.dmarc_record === "true"
                                  ? "bg-success bg-opacity-10 text-success"
                                  : "bg-danger bg-opacity-10 text-danger"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  reportData.dmarc_record === "true"
                                    ? "bi-check-circle-fill me-1"
                                    : "bi-x-circle-fill me-1"
                                }`}
                              ></i>
                              {reportData.dmarc_record === "true"
                                ? t.present
                                : t.notPresent}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="ps-4 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-shield-lock me-2 text-muted"></i>
                            SPF Record
                          </td>
                          <td className="pe-4 p-0">
                            <div
                              className={`px-3 py-1 rounded-5 d-flex align-items-center ${
                                reportData.spf_record === "true"
                                  ? "bg-success bg-opacity-10 text-success"
                                  : "bg-danger bg-opacity-10 text-danger"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  reportData.spf_record === "true"
                                    ? "bi-check-circle-fill me-1"
                                    : "bi-x-circle-fill me-1"
                                }`}
                              ></i>
                              {reportData.spf_record === "true"
                                ? t.present
                                : t.notPresent}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="ps-4 py-3 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-bug me-2 text-muted"></i>
                            Malware
                          </td>
                          <td className="pe-4 p-0">
                            <div
                              className={`px-3 py-1 rounded-5 d-flex align-items-center ${
                                reportData.malware === "true"
                                  ? "bg-danger bg-opacity-10 text-danger"
                                  : "bg-success bg-opacity-10 text-success"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  reportData.malware === "true"
                                    ? "bi-exclamation-triangle-fill me-1"
                                    : "bi-check-circle-fill me-1"
                                }`}
                              ></i>
                              {reportData.malware === "true"
                                ? t.detected
                                : t.notDetected}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="ps-4 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-exclamation-triangle me-2 text-muted"></i>
                            Phishing Risk
                          </td>
                          <td className="pe-4 p-0">
                            <div
                              className={`px-3 py-1 rounded-5 d-flex align-items-center ${
                                reportData.phishing === "true"
                                  ? "bg-warning bg-opacity-10 text-warning"
                                  : "bg-success bg-opacity-10 text-success"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  reportData.phishing === "true"
                                    ? "bi-exclamation-triangle-fill me-1"
                                    : "bi-shield-fill me-1"
                                }`}
                              ></i>
                              {reportData.phishing === "true"
                                ? t.highRisk
                                : t.lowRisk}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="ps-4 py-3 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-megaphone me-2 text-muted"></i>
                            Spamming
                          </td>
                          <td className="pe-4 p-0">
                            <div
                              className={`px-3 py-1 rounded-5 d-flex align-items-center ${
                                reportData.spamming === "true"
                                  ? "bg-danger bg-opacity-10 text-danger"
                                  : "bg-success bg-opacity-10 text-success"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  reportData.spamming === "true"
                                    ? "bi-exclamation-triangle-fill me-1"
                                    : "bi-check-circle-fill me-1"
                                }`}
                              ></i>
                              {reportData.spamming === "true"
                                ? t.detected
                                : t.notDetected}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="ps-4 py-3 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-speedometer2 me-2 text-muted"></i>
                            Risk Score
                          </td>
                          <td className="pe-4 p-0">
                            <div className="d-flex align-items-center">
                              <div
                                className="progress "
                                style={{ height: "8px" }}
                              >
                                <div
                                  className={`progress-bar ${
                                    reportData.risk_score > 70
                                      ? "bg-danger"
                                      : reportData.risk_score > 40
                                      ? "bg-warning"
                                      : "bg-success"
                                  }`}
                                  role="progressbar"
                                  style={{
                                    width: `${reportData.risk_score || 0}%`,
                                  }}
                                ></div>
                              </div>
                              <span className="ms-2 fw-bold">
                                {reportData.risk_score || 0}
                              </span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>

              <Card className="mb-4 border-0 shadow-sm">
                <Card.Header
                  className="text-white py-3"
                  style={{
                    backgroundColor: "#23416c",
                    background:
                      "linear-gradient(135deg, #23416c 0%, #3a6ea5 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center ">
                    <i className="bi bi-shield-fill-check me-2"></i>
                    <strong>DOMAIN INTEGRITY & REPUTATION</strong>
                  </h5>
                </Card.Header>

                <Card.Body className="p-0">
                  <div className="table-responsive">
                    <Table hover className="mb-0 align-middle">
                      <tbody>
                        <tr>
                          <td
                            width="40%"
                            className="ps-4 fw-semibold d-flex align-items-center"
                          >
                            <i className="bi bi-check-circle me-2 text-muted"></i>
                            {t.dnsValid}
                          </td>
                          <td width="60%" className="pe-4 p-0">
                            <div
                              className={`px-3 py-1 rounded-5 d-flex align-items-center ${
                                reportData.dns_valid === "true"
                                  ? "bg-success bg-opacity-10 text-success"
                                  : "bg-danger bg-opacity-10 text-danger"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  reportData.dns_valid === "true"
                                    ? "bi-check-circle-fill me-1"
                                    : "bi-x-circle-fill me-1"
                                }`}
                              ></i>
                              {reportData.dns_valid === "true"
                                ? t.valid
                                : t.invalid}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="ps-4 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-trophy me-2 text-muted"></i>
                            {t.domainRank}
                          </td>
                          <td className="pe-4 p-0">
                            <div className="d-flex align-items-center">
                              <div
                                className="progress "
                                style={{ height: "8px" }}
                              >
                                <div
                                  className={`progress-bar ${
                                    reportData.domain_rank > 70
                                      ? "bg-success"
                                      : reportData.domain_rank > 40
                                      ? "bg-primary"
                                      : "bg-secondary"
                                  }`}
                                  role="progressbar"
                                  style={{
                                    width: `${reportData.domain_rank || 0}%`,
                                  }}
                                ></div>
                              </div>
                              <span className="ms-2 py-0 fw-bold">
                                {reportData.domain_rank || 0}
                              </span>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="ps-4 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-exclamation-octagon me-2 text-muted"></i>
                            {t.adultContent}
                          </td>
                          <td className="pe-4 p-0">
                            <div
                              className={`px-3 py-1 rounded-5 d-flex align-items-center ${
                                reportData.adult === "true"
                                  ? "bg-danger bg-opacity-10 text-danger"
                                  : "bg-success bg-opacity-10 text-success"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  reportData.adult === "true"
                                    ? "bi-exclamation-triangle-fill me-1"
                                    : "bi-check-circle-fill me-1"
                                }`}
                              ></i>
                              {reportData.adult === "true" ? t.present : t.none}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="ps-4 py-3 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-p-square me-2 text-muted"></i>
                            {t.parking}
                          </td>
                          <td className="pe-4 p-0">
                            <div
                              pill
                              className={`px-3 py-1 rounded-5 d-flex align-items-center ${
                                reportData.parking === "true"
                                  ? "bg-warning bg-opacity-10 text-warning"
                                  : "bg-success bg-opacity-10 text-success"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  reportData.parking === "true"
                                    ? "bi-exclamation-triangle-fill me-1"
                                    : "bi-check-circle-fill me-1"
                                }`}
                              ></i>
                              {reportData.parking === "true"
                                ? t.detected
                                : t.none}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="ps-4 py-3 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-flag me-2 text-muted"></i>
                            {t.riskyTld}
                          </td>
                          <td className="pe-4 p-0 py-1">
                            <div
                              className={`px-3 py-1 rounded-5 d-flex align-items-center ${
                                reportData.risky_tld === "true"
                                  ? "bg-warning bg-opacity-10 text-warning"
                                  : "bg-success bg-opacity-10 text-success"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  reportData.risky_tld === "true"
                                    ? "bi-exclamation-triangle-fill me-1"
                                    : "bi-check-circle-fill me-1"
                                }`}
                              ></i>
                              {reportData.risky_tld === "true" ? t.yes : t.no}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="ps-4 py-3 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-eye-slash me-2 text-muted"></i>
                            Suspicious
                          </td>
                          <td className="pe-4 p-0">
                            <div
                              className={`px-3 py-1 rounded-5 d-flex align-items-center ${
                                reportData.suspicious === "true"
                                  ? "bg-danger bg-opacity-10 text-danger"
                                  : "bg-success bg-opacity-10 text-success"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  reportData.suspicious === "true"
                                    ? "bi-exclamation-triangle-fill me-1"
                                    : "bi-check-circle-fill me-1"
                                }`}
                              ></i>
                              {reportData.suspicious === "true" ? t.yes : t.no}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="ps-4 main_padding fw-semibold d-flex align-items-center">
                            <i className="bi bi-shield-slash me-2 text-muted"></i>
                            Unsafe
                          </td>
                          <td className="pe-4 p-0">
                            <div
                              className={`px-3 py-1 rounded-5 d-flex align-items-center ${
                                reportData.unsafe === "true"
                                  ? "bg-danger bg-opacity-10 text-danger"
                                  : "bg-success bg-opacity-10 text-success"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  reportData.unsafe === "true"
                                    ? "bi-exclamation-triangle-fill me-1"
                                    : "bi-check-circle-fill me-1"
                                }`}
                              ></i>
                              {reportData.unsafe === "true" ? t.yes : t.no}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Card.Body>
            <Card.Footer className="bg-light border-top py-3">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center small text-muted">
                <div className="mb-2 mb-md-0">
                  <span className="d-inline-flex align-items-center">
                    <i className="bi bi-shield-lock me-1"></i>
                    <strong>{t.scanId}:</strong> {reportData._id || t.na}
                  </span>
                </div>

                <div className="mb-2 mb-md-0">
                  <span className="d-inline-flex align-items-center">
                    <i className="bi bi-clock-history me-1"></i>
                    {new Date().toLocaleString("en-US", {
                      weekday: "short",
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>
              </div>
            </Card.Footer>
          </Card>
        </div>
      </div>
    </div>
  );
}
